export enum OrderActionType {
    removeOrderInstallments = 'removeOrderInstallments',
    resetOrder = 'resetOrder',
    saveEventShippingSettings = 'saveEventShippingSettings',
    saveWaitlistEntry = 'saveWaitlistEntry',
    setCanRetrySubmit = 'setCanRetrySubmit',
    setHasExternalPaymentFirstCallCompleted = 'setHasExternalPaymentFirstCallCompleted',
    setHasRetryPaymentError = 'setHasRetryPaymentError',
    setHasVirtualIncentivesErrors = 'setHasVirtualIncentivesErrors',
    setOrderInstallments = 'setOrderInstallments',
    setOrderUpdating = 'setOrderUpdating',
    taxPoliciesLoadComplete = 'taxPoliciesLoadComplete',
    updateAvailablePaymentMethods = 'updateAvailablePaymentMethods',
    updateBraintreeClientToken = 'updateBraintreeClientToken',
    updateOrder = 'updateOrder',
    updateOrderAttendees = 'updateOrderAttendees',
    updateOrderEmail = 'updateOrderEmail',
    updateOrderStatus = 'updateOrderStatus',
    updateRedirectInstructions = 'updateRedirectInstructions',
    updateTaxExemptionMessage = 'updateTaxExemptionMessage',
}
